import { render } from "./LivePaperTrading.vue?vue&type=template&id=7451d921"
import script from "./LivePaperTrading.vue?vue&type=script&lang=js"
export * from "./LivePaperTrading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__